import Breadcrumb from "../Component/Breadcrumb";
const ClassActivity = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="Class Activities"
        breadmid="Academic "
        breadend="Class Activities"
      />
      <div className="innerpage library_blk">
        <div className="container">
          <div class="row g-3">
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act1.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act1.jpg"
                  />
                </a>
              </div>
            </div>

            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act2.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act2.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act3.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act3.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act4.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act4.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act5.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act5.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act6.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act6.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act7.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act7.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act8.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act8.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act9.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act9.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act10.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act10.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act11.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act11.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act12.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act12.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act13.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act13.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act14.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act14.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act15.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act15.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act16.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act16.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <div className="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act17.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid w-100"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cls-act17.jpg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ClassActivity;
